import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { Add, Delete, Visibility } from '@material-ui/icons';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import { Link, useNavigate } from 'react-router-dom';
import { wsGetAll, wsRemove } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';
import { wsFindBy } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 115 },
  { Header: 'Estado', accessor: 'state_migrate', width: 120 },
  { Header: 'Estado SAP', accessor: 'u_syp_status', width: 120 },
  { Header: 'Proveedor', accessor: 'CardName' },
  { Header: 'Documento', accessor: 'document', width: 120 },
  { Header: 'Referencia', accessor: 'purchase', width: 120 },
  { Header: 'Total', accessor: 'DocTotal', width: 150 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150 },
  { Header: 'Fecha documento', accessor: 'TaxDate', width: 170 },
  { Header: 'Fecha contable', accessor: 'DocDate', width: 170 },
  { Header: 'Fecha vencimiento', accessor: 'DocDueDate', width: 170 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function PurchaseDebitNoteList() {
  const navigate = useNavigate();
  const [debitNotes, setDebitNotes] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listDebitNotes(filter) {
    setDataLoading(true);
    let res = await wsFindBy('purch/debit-note', filter);
    setDataLoading(false);
    if (res.success) {
      setDebitNotes(res.data);
    }
  }

  async function processCancelDebitNote(debitNoteId) {
    if (!window.confirm('¿Seguro de anular la nota de débito?\nEsta acción no es reversible')) return;
    setDataLoading(true);
    const res = await wsRemove('purch/cdebit-note', debitNoteId);
    setDataLoading(false);
    if (res.success) {
      window.alert(res.message);
    } else {
      window.alert(`Error: ${res.message}`);
    }
  }

  // useEffect(() => {
  //   listDebitNotes();
  // }, []);

  return (
    <CardContainer /*title="Notas de crédito compras"*/ title={(<>Notas de débito compras {dataLoading && <LoadingSpinner />}</>)} icon={<Add />} onClick={() => {
      navigate('0');
    }}>
      <FilterCustom
        getFilter={listDebitNotes}
        dateRange
        diffRange={7}
        provider
        typePurchDebitNote
        typePurchDebitNoteSap
      />
      <ReactTable
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={debitNotes.map((debitNote, index) => {
          let state_migrate = debitNote.state_migrate;
          switch (debitNote.state_migrate) {
            case 'D':
              state_migrate = 'Borrador';
              break;
            case 'V':
              state_migrate = 'Validado';
              break;
            case 'X':
              state_migrate = 'Procesando...';
              break;
            case 'P':
            case 'Y':
              state_migrate = 'Procesado';
              break;
          }
          let u_syp_status = debitNote.opch?.u_syp_status;
          switch (u_syp_status) {
            case 'V':
              u_syp_status = 'Vigente';
              break;
            case 'A':
              u_syp_status = 'Anulado SUNAT';
              break;
            case 'I':
              u_syp_status = 'Anulado Interno';
              break;
            default:
              u_syp_status = 'Sin estado definido';
          }

          return {
            num: (
              <div className="actions-right">
                {index + 1}
                <Link to={`${debitNote.id}`} disabled={dataLoading}>
                  <Visibility />
                </Link>
                <RegularButton
                  justIcon simple round color="danger"
                  onClick={() => processCancelDebitNote(debitNote.id)}
                  disabled={dataLoading || debitNote.state_migrate !== 'Y' && debitNote.sapAnnuled === null}
                >
                  <Delete />
                </RegularButton>
                <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_DELETED}>
                  <ButtonDelete
                    entity="purch/debit-note-eliminar"
                    id={debitNote.id}
                    reload={() => listDebitNotes()}
                  />
                </AllowedGuard>
              </div>
            ),
            state_migrate,
            u_syp_status,
            CardName: debitNote.provider.CardName,
            document: `${debitNote.U_SYP_MDSD}-${debitNote.U_SYP_MDCD}`,
            purchase: `${debitNote.U_SYP_MDSO}-${debitNote.U_SYP_MDCO}`,
            DocTotal: debitNote.DocTotal,
            created_at: debitNote.created_at,
            TaxDate: debitNote.TaxDate,
            DocDate: debitNote.DocDate,
            DocDueDate: debitNote.DocDueDate,
          };
        })}
      />
    </CardContainer>
  );
}

export default PurchaseDebitNoteList;
